import React from 'react';
import type { CSSProperties } from 'react';
import { isKatipPlaceholderWorkplaceName } from '../utils/katipPlaceholderWorkplace';

type Props = {
  name: string | null | undefined;
  className?: string;
  style?: CSSProperties;
  /** Uzun isimleri kısaltır; fareyle tam metin title'da kalır */
  maxLen?: number;
};

export default function WorkplaceNameDisplay({ name, className, style, maxLen }: Props) {
  const placeholder = isKatipPlaceholderWorkplaceName(name);
  const full = String(name ?? '').trim() || '';
  let displayText = full || '—';
  if (maxLen != null && displayText !== '—' && displayText.length > maxLen) {
    displayText = `${displayText.slice(0, maxLen)}…`;
  }

  const baseTitle =
    placeholder
      ? 'İSG Katip bu kayıt için işyeri unvanı göndermedi. Yer tutucu isim kullanılıyor; Katip düzelince senkronla güncellenir.'
      : undefined;
  let titleAttr: string | undefined;
  if (placeholder) titleAttr = baseTitle;
  else if (maxLen != null && full.length > maxLen) titleAttr = full;
  else titleAttr = undefined;

  return (
    <span
      className={className}
      style={{
        ...style,
        ...(placeholder ? { color: '#dc2626', fontWeight: 600 } : {}),
      }}
      translate={placeholder ? 'no' : undefined}
      title={titleAttr}
    >
      {displayText}
    </span>
  );
}
